//import Wow from 'wow.js';
import Swiper from 'swiper/dist/js/swiper.js';
import 'is-in-viewport';

export default {
  init() {
    // JavaScript to be fired on all pages
    jQuery(window).load(function(){ jQuery(".loader").fadeOut("200"); });
    jQuery(window).on('beforeunload', function(){ jQuery(".loader").fadeIn("1500"); });
    var AusoneSlider = false;
    var alreadyTranslate = false;

    let elements = document.querySelectorAll('[data-responsive-background-image], [data-responsive-large-background-image], [data-responsive-extralarge-background-image]');
    for (let i=0; i<elements.length; i++) {
      new ResponsiveBackgroundImage(elements[i]);
    }

    function isMobile() {
      if (window.matchMedia("(max-width: 736px)").matches) {
          return true;
      } else {
          return false;
      }
    }

    function animateThis() {
      var timer = 350;
      var animationType = 'fadeInUpLight';
      if(!alreadyTranslate) {
        alreadyTranslate = true;
        jQuery('[data-animated]').each(function() {
          if(!isMobile()) {
            animationType = jQuery(this).data('animated');
            if(jQuery(this).is(':in-viewport')) {
              jQuery(this).addClass('animated');
              jQuery(this).addClass(animationType);
            }
          } else {
            timer = 100;
            if(jQuery(this).is(':in-viewport')) {
              jQuery(this).addClass('animated');
              jQuery(this).addClass(animationType);
            } /*else {
              jQuery(this).removeClass('animated');
              jQuery(this).removeClass(animationType);
            }*/
          }
        });
        setTimeout(function() {
          alreadyTranslate = false;
          if (AusoneSlider && typeof AusoneSlider == 'object' && AusoneSlider.initialized) {
            //AusoneSlider.update();
          }
        }, timer);
      }
    }

    function fixSwiperHeight() {
      var heightContainer = jQuery(window).height() - jQuery('.swiper-pagination').outerHeight() - jQuery('.nav-container').outerHeight() - jQuery('footer').outerHeight() - 20;

      if(jQuery('.ausone-container').hasClass('full-height')) {
        heightContainer = jQuery(window).height();
      }

      if (isMobile()) {
        if (AusoneSlider && typeof AusoneSlider == 'object' && AusoneSlider.initialized) {
          AusoneSlider.destroy();
        }

        let elements = document.querySelectorAll('[data-mobile-responsive-background-image]');
        for (let i=0; i<elements.length; i++) {
          new ResponsiveBackgroundImage(elements[i]);
        }

        animateThis();
        jQuery(window).scroll(function() {
          animateThis();
        });
        jQuery(document).on('touchstart', function() {
          animateThis();
        });
        jQuery(document).on('touchmove', function() {
          animateThis();
        });
      } else {
        jQuery('.ausone-container').css({
          height: heightContainer,
        });

        if (AusoneSlider && typeof AusoneSlider == 'object' && AusoneSlider.initialized) {
          AusoneSlider.update();
        } else {
          AusoneSlider = new Swiper('.ausone-container', {
            slidesPerView: 'auto',
            height: heightContainer,
            freeMode: true,
            freeModeMomentum: true,
            freeModeMomentumBounce: true,
            /*freeModeSticky: true,*/
            spaceBetween: 0,
            /*centeredSlides: false,
            centerInsufficientSlides: false,*/
            preloadImages: true,
            updateOnImagesReady: true,
            simulateTouch: false,
            mousewheel: true,
            mousewheelSensitivity: 0,
            mousewheelReleaseOnEdges: false,
            /*speed: 2000,*/
            /*parallax: true,
            hashNavigation: {
              watchState: true,
              replaceState: true,
            },*/
            scrollbar: {
              el: '.swiper-scrollbar',
            },
            navigation: {
              nextEl: '.ausone-button-next',
              prevEl: '.ausone-button-prev',
            },
            /*pagination: {
              el: '.swiper-pagination',
              type: 'progressbar',
            },*/
            keyboard: {
              enabled: true,
            },
            on: {
              reachEnd: function() {
                jQuery('.next-link').removeClass('active');
                jQuery('.prev-link').removeClass('active');
                if(this.isEnd) {
                  jQuery('.next-link').addClass('active');
                }
              },
              reachBeginning: function() {
                jQuery('.next-link').removeClass('active');
                jQuery('.prev-link').removeClass('active');
                if(this.isBeginning) {
                  jQuery('.prev-link').addClass('active');
                }

              },
              setTransition: function() {
                setTimeout(() => {
                  animateThis();
                }, 200);
              },
              slideChange: function() {
                animateThis();
                jQuery('.next-link').removeClass('active');
                jQuery('.prev-link').removeClass('active');
                if( this.isBeginning ) {
                  jQuery('.prev-link').addClass('active');
                }
                else if( this.isEnd ) {
                  jQuery('.next-link').addClass('active');
                }
                this.update();
              },
              init: function () {
                animateThis();
                jQuery('.next-link').removeClass('active');
                jQuery('.prev-link').removeClass('active');
                if (this.isBeginning) {
                  jQuery('.prev-link').addClass('active');
                } else if (this.isEnd) {
                  jQuery('.next-link').addClass('active');
                }
              },
            },
          });
        }
      }
    }

    jQuery(window).on("resize orientationchange", function () {
      fixSwiperHeight();
    });
    fixSwiperHeight();

    jQuery(document).ready(function() {
      if(AusoneSlider && typeof AusoneSlider == 'object' && AusoneSlider.initialized) {
        AusoneSlider.update();
        jQuery('.ausone-container').focus();
      }
    });

    jQuery('.nav-icon').on('click', function() {
      jQuery(".main-menu").animate({ scrollTop: 0 }, "slow");
      if (jQuery(this).hasClass('animate-icon')) {
        jQuery(this).removeClass('animate-icon');
        jQuery('.main-menu, #menu-principal, #prooftag, #pro, #mentions-legales').removeClass('active');
        jQuery('.shadow-menu').hide();
        jQuery('.ausone-container').css('z-index', 'auto');
        jQuery('body').delay(400).removeClass('active-menu');
      } else {
        jQuery(this).addClass('animate-icon');
        jQuery('body').addClass('active-menu');
        jQuery('.main-menu, #menu-principal').addClass('active');
        jQuery('.shadow-menu').fadeIn(1000);
        jQuery('.ausone-container').css('z-index', '-1');
      }
    });

    if (window.location.hash.substr(1) == 'pro' || window.location.hash.substr(1) == 'prooftag' || window.location.hash.substr(1) == 'mentions-legales') {
      window.location.hash = '';
    }

    jQuery('a[change-menu]').on('click', function() {
      let href = jQuery(this).attr('href');
      let hash = window.location.hash.substr(1);
      jQuery('#menu-principal, #pro, #prooftag, #mentions-legales').removeClass('active');
      jQuery(href).addClass('active');

      if (hash == 'menu-principal') {
        window.location.hash = '';
      }

      jQuery(".main-menu").animate({ scrollTop: 0 }, "slow");
    });

    jQuery("#form-prooftag").submit(function(event) {
      event.preventDefault();
      let tag = jQuery("#form-prooftag input[name=tag]").val();
      //jQuery('#prooftag_ok_button').hide();
      //jQuery('#prooftag_loader').show();
      jQuery('#prooftag_ok_button').attr('disabled', 'disabled');
      jQuery.post(
        ajaxurl, // eslint-disable-line
        {
            'action': 'prooftag',
            'tag': tag,
        },
        function(response) {
          jQuery('#please_fill_code').hide();
          if (response) {
            jQuery('#server_message').html(response.msg);
            jQuery('#product_description').html(response.product_description);
            jQuery('#tag_image').html(response.tag_img);
            jQuery('#tag_image_explanations').html(response.tag_img_explanations);
            jQuery('#product_image').html(response.product_img);
            jQuery('#product_description').show();
            jQuery('#tag_image').show();
            jQuery('#tag_image_explanations').show();
            jQuery('#product_image').show();
          } else {
            jQuery('#server_message').html(response.msg);
          }
          jQuery('#server_message').show();

          //jQuery('#prooftag_ok_button').show();
          //jQuery('#prooftag_loader').hide();
          jQuery('#prooftag_ok_button').removeAttr('disabled');
        },
        "json"
      );
    });

    jQuery("#form-pro").submit(function(event) {
      event.preventDefault();
      let propass = jQuery("#form-pro input[name=propass]").val();
      jQuery('#proaccess_ok_button').attr('disabled', 'disabled');
      //jQuery('#proaccess_ok_button').hide();
      //jQuery('#proaccess_loader').show();
      jQuery.post(
        ajaxurl, // eslint-disable-line
        {
            'action': 'proaccess',
            'propass': propass,
        },
        function(response){
          if(response.result) {
            jQuery('#form-pro').replaceWith(response.proData);
          }
          jQuery('#messageproaccess').html(response.message);
          jQuery('#proaccess_ok_button').removeAttr('disabled');
          //jQuery('#proaccess_ok_button').show();
          //jQuery('#proaccess_loader').hide();
        },
        "json"
      );
    });
    jQuery(".lien-mentions").on("click", function() {
      var data = {
        'action': 'load_posts_by_ajax',
      };

      jQuery.post(ajaxurl, data, function(response) { // eslint-disable-line
        jQuery('#mentions-legales .results-zone').html(response);
      }, "html");
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

export class ResponsiveBackgroundImage {
  constructor(element) {
      this.element = element;
      this.img = element.querySelector('img');
      this.src = '';

      if(this.img != null) {
        this.img.addEventListener('load', () => {
          this.update();
        });

        if (this.img.complete) {
            this.update();
        }
      }
  }

  update() {
      let src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
      if (this.src !== src) {
          this.src = src;
          this.element.style.backgroundImage = 'url("' + this.src + '")';
      }
  }
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js